module.exports = "/build/web/images/socials.e091c5b0d05e7a819cbe91f5a5bd2729.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/socials.jpg
// module id = 137
// module chunks = 24